export default __webpack_public_path__ + "static/media/5.899b8013.jpg";